import Resource from '@/api/resources/Resource'

class PersonnelEventsForEventManagersServices extends Resource {
    async paginator(filterModel, params, laboratoryId) {
        const response = await this.axios.put(`/laboratories/${laboratoryId}/personnelEvents`, filterModel, { params })
        return response.data
    }
    async confirmUnconfirmedPersonnelEvent(personnelId, personnelEventId, laboratoryId) {
        const response = await this.axios.put(`/laboratories/${laboratoryId}/personnel/${personnelId}/personnelEvents/${personnelEventId}/confirm`)
        return response.data
    }
    async updatePersonnelEvent(request, personnelId, personnelEventId, laboratoryId) {
        const response = await this.axios.put(`/laboratories/${laboratoryId}/personnel/${personnelId}/personnelEvents/${personnelEventId}`, request)
        return response.data
    }
    async createAndConfirmPersonnelEvent(request, personnelId, laboratoryId) {
        const response = await this.axios.post(`/laboratories/${laboratoryId}/personnel/${personnelId}/personnelEvents`, request)
        return response.data
    }
    async deletePersonnelEvent(personnelId, personnelEventId, laboratoryId) {
        const response = await this.axios.delete(`/laboratories/${laboratoryId}/personnel/${personnelId}/personnelEvents/${personnelEventId}`)
        return response.data
    }
    async getLaboratoryUnconfirmedPersonnelEvents(laboratoryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/personnelEvents/countUnconfirmed`)
        return response.data
    }
}

export default new PersonnelEventsForEventManagersServices()
